import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PanoramaFisheyeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"panorama_fisheye"}/>
}
